import { createTheme } from '@mui/material/styles';
import { accent0 } from 'emerald-ui/dist/globals/colors';

/**
 * MUI currently doesn't export createPalette. In order to create a palette independently from the theme,
 * we need to create a temporary theme and pull the palette out of it. This is necessary so that elements of the theme
 * can access the palette before the theme is constructed.
 */
export const palette = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: accent0,
        },
    },
}).palette;
